import React from 'react';

import { xcss, Flex } from '@atlaskit/primitives';

import { ReactionContainerType, ReactionLocation } from '@confluence/reactions';
import { ReactionsLoader } from '@confluence/reactions/entry-points/ReactionsLoader';

type ObjectSidebarReactionsPickerProps = {
	contentId: string;
	spaceId: string;
	isDisabled?: boolean;
	contentType?: string;
	contentSubType?: string;
	isSpaceOverview?: boolean;
};

// Offsetting some styles in Reactions container component which is adding a margins
// If modifying these styles, make sure to update ReactionsPlaceholder.tsx as well
const pickerContainerStyles = xcss({
	marginTop: 'space.0',
});

export const ObjectSidebarReactionsPicker = ({
	contentId,
	spaceId,
	isDisabled = false,
	contentType,
	contentSubType,
	isSpaceOverview,
}: ObjectSidebarReactionsPickerProps) => {
	const containerType = isSpaceOverview
		? ReactionContainerType.SPACE
		: contentType === 'blog'
			? ReactionContainerType.BLOGPOST
			: ReactionContainerType.PAGE;
	const location = contentType === 'blog' ? ReactionLocation.BLOGPOST : ReactionLocation.PAGE;

	return (
		<Flex
			testId="object-side-bar-reactions"
			justifyContent="center"
			alignItems="center"
			xcss={pickerContainerStyles}
		>
			<ReactionsLoader
				contentId={contentId}
				location={location}
				containerId={spaceId}
				containerType={containerType}
				contentSubType={contentSubType}
				summaryViewEnabled
				hideNoReactionsText
				readOnly={isDisabled}
				hidePlaceholder={Boolean(process.env.REACT_SSR || window.__SSR_RENDERED__)}
				showAddReactionText={false}
				isSubtle
				onlyRenderPicker
				showRoundTrigger
			/>
		</Flex>
	);
};
